import ym from 'react-yandex-metrika';

import { downloadDocumentsType, viewDocumentsType } from './constants';

const isProd = process.env.NODE_ENV === 'production';

export const openDocumentTrack = (type) => {
  return isProd && ym('reachGoal', viewDocumentsType[type]);
};
export const loadDocumentTrack = (type) => {
  return isProd && ym('reachGoal', downloadDocumentsType[type]);
};
